//@ts-ignore
import React from 'react';
import { FC, useState } from 'react';
import { Root, Loader, Logo, Spinner, IframeStyled } from './style';
import { Props } from './types';
import IframeStyledHOC from './IframeStyledHOC';

const Iframe: FC<Props & { children?: any }> = ({ src, logoSrc, useModernPlayer, ...rest }) => {
  const [loading, setLoading] = useState<boolean>(true);

  const hideSpinner = () => {
    setLoading(false);
  };

  return (
    <Root>
      {loading && (
        <Loader>
          <Spinner />
          {logoSrc && (
            <Logo>
              <img src={logoSrc} alt="" />
            </Logo>
          )}
        </Loader>
      )}
      {useModernPlayer ? (
        <IframeStyledHOC width="100%" height="100%" src={src} onLoad={hideSpinner} {...rest} />
      ) : (
        <IframeStyled
          width="100%"
          height="100%"
          src={src}
          allow="geolocation;camera;microphone"
          onLoad={hideSpinner}
          {...rest}
        />
      )}
    </Root>
  );
};

export default Iframe;
